import * as moment from 'moment';
import { Action, combineReducers } from '@ngrx/store';

import { OA } from '../category-types';

import { Batch } from '../../app/models';

import {
  _CLEAR,
  CREATE_BATCH,
  CREATE_BATCHES,
  DELETE_BATCH,
  GET_BATCH_AMOUNTS,
  GET_FORMATTED_BATCHES,
  GET_OA_BATCH_AMOUNTS,
  GET_SORTED_OA_BATCHES,
  GET_BATCHES,
  GET_PTO_BATCHES,
  GET_PTO_PREPRINT_BATCHES,
  SET_BATCH_DETAILS_VIEW,
  SET_BATCH_LIST_VIEW,
  UPDATE_BATCH,
  GET_PTO_PRINTING_BATCHES,
  GET_PTO_SEALED_PRINTING_BATCHES
} from '../actions';

const initialBatchDetailsViewState = {
  error  : <string>'',
  loading: <boolean>false
};

const initialBatchListViewState = {
  cuttingView        : <string>'',
  diePressureUpdating: <boolean>false,
  loading            : <boolean>false,
  mtsWorkOrdersPrinting: <boolean>false,
  scrapLoading       : <boolean>false,
  sendBatches        : <boolean>false,
  switchingBatch     : <boolean>false,
  invalidMaterialScan: <string>'',
  invalidDieScan     : <string>'',
  dieLoading         : <boolean>false,
  materialLoading    : <boolean>false,
};

export function batchAmountsReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_BATCH_AMOUNTS: 
      return [...action.payload.batchAmounts];
    default: 
      return state;
  }
}

export function oaBatchAmountsReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_OA_BATCH_AMOUNTS: 
      return [ ...action.payload.batchAmounts ];
    default: 
      return state;
  }
}

export function batchDetailsViewReducer(state = initialBatchDetailsViewState, action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return Object.assign({}, state, initialBatchDetailsViewState)
    case SET_BATCH_DETAILS_VIEW: 
      return Object.assign({}, state, action.payload);
    default: 
      return state;
  }
}

export function formattedBatchListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return [];
    case GET_FORMATTED_BATCHES: 
      return action.payload.batches.length
        ? action.payload.batches.sort(sortBatches)
        : [];
    default: 
      return state;
  }
}

export function batchListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return [];
    case CREATE_BATCH: 
      const match = state.find(batch => action.payload.batch && batch.id === action.payload.batch.id);
      return !match
        ? [ ...state, action.payload.batch ].sort(sortBatches)
        : state;
    case DELETE_BATCH: 
      return state.filter(batch => batch.id !== action.payload.id);
    case GET_BATCHES: 
      return action.payload.batches.length
        ? action.payload.batches.sort(sortBatches)
        : state;
    case UPDATE_BATCH: 
      return state.map(batch => {
        return batch.id === action.payload.id
          ? updateBatch(batch,action.payload.diffList)
          : batch;
      });
    default: 
      return state;
  }
}

function updateBatch(batch: Batch, diffList): any {
  diffList.forEach(diff => {
    if(diff.path == "activity_history"){
      var newActs =  batch["activity_history"].concat(diff.newVal);
      batch["activity_history"] = newActs;
    } else if (diff.path == "batchStatus"){
      batch['status'] = diff.newVal; 
      batch['batchStatus'] = diff.newVal;
    } else {
      batch[diff.path] = diff.newVal; 
    }
  });
  return batch;
}

export function batchListViewReducer(state = initialBatchListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return Object.assign({}, state, initialBatchListViewState);
    case SET_BATCH_LIST_VIEW: 
      return Object.assign({}, state, action.payload);
    default: 
      return state;
  }
}

export function sortedOABatchesReducer(state = {}, action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return state;
    case GET_SORTED_OA_BATCHES: 
      return action.payload.batches;
    default: 
      return state;
  }
}
// This contains all PTO Batches regardless of status
export function ptoBatchesReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return state;
    case GET_PTO_BATCHES: 
      return action.payload.ptoBatches;
    default: 
      return state;
  }
}
export function ptoPreprintBatchesReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return state;
    case GET_PTO_PREPRINT_BATCHES: 
      return action.payload.ptoPreprintBatches;
    default: 
      return state;
  }
}
export function ptoPrintingBatchesReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return state;
    case GET_PTO_PRINTING_BATCHES: 
      return action.payload.ptoPrintingBatches;
    default: 
      return state;
  }
}

export function ptoSealedPrintingBatchesReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return state;
    case GET_PTO_SEALED_PRINTING_BATCHES: 
      return action.payload.ptoSealedPrintingBatches;
    default: 
      return state;
  }
}

function sortBatches(batch1, batch2) {
  const date1 = new Date(batch1.dueDate).getTime();
  const date2 = new Date(batch2.dueDate).getTime();

  return +date1 - +date2;
}

export const batchReducers = combineReducers({
  batchAmounts      : batchAmountsReducer,
  oaBatchAmounts    : oaBatchAmountsReducer,
  batchDetailsView  : batchDetailsViewReducer,
  batchList         : batchListReducer,
  batchListView     : batchListViewReducer,
  formattedBatchList: formattedBatchListReducer,
  sortedOABatches   : sortedOABatchesReducer,
  ptoBatches        : ptoBatchesReducer,
  ptoPreprintBatches: ptoPreprintBatchesReducer,
  ptoPrintingBatches: ptoPrintingBatchesReducer,
  ptoSealedPrintingBatches: ptoSealedPrintingBatchesReducer,
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/batches.ts